module.exports = __webpack_public_path__ + "nunito-sans-latin-800italic.0117d6315806b392f7da0d5d3aa9c7ca.woff2";